import { useQuery } from '@tanstack/react-query';
import { UserConverter } from "shared/domain/converter/user.converter";
import { IPaginationInputMeta } from "shared/domain/pagination/pagination-meta";
import { RestEndpoints } from "../../../../api/endpoints";
import { ReactQueryConfig } from "../../../../config/react-query-config";
import getInstance from "../../../../utils/rest";
import { PaginationMetaConverter } from "../../../domain/converter/pagination-meta.converter";
import { IUserResult } from "../../../domain/user/user";
import { IUserResultModel } from "../../../models/user/user.model";
import { SharedQueryKeys } from "../shared-query-keys";

export const getRelatedWasteProducerUsers = async (
  id: number | undefined,
  searchText: string | undefined,
  paginationInputMeta?: IPaginationInputMeta,
): Promise<IUserResult | undefined> => {
  if (!id) return undefined;
  const url = RestEndpoints.UserRelatedWasteProducers.replace(":id", id.toString());

  const response = await getInstance().get<IUserResultModel>(url, {
    params: {
      query: searchText,
      page: paginationInputMeta?.page,
      pageSize: paginationInputMeta?.pageSize,
    },
  });

  const data: IUserResult = {
    users: response.data.users.map(UserConverter.toDomain),
    meta: response.data.meta ? PaginationMetaConverter.toDomain(response.data.meta) : response.data.meta,
  };

  return data;
};

export const useGetRelatedWasteProducerUsers = (
  id: number | undefined,
  searchText: string | undefined,
  paginationInputMeta?: IPaginationInputMeta,
) => {
  return useQuery({
    queryKey: [SharedQueryKeys.GetRelatedWasteProducerUsers, id, searchText],
    queryFn: () => getRelatedWasteProducerUsers(id, searchText, paginationInputMeta),
    staleTime: ReactQueryConfig.staleTime,
    enabled: Number.isFinite(id)
  });
};
